import { render, staticRenderFns } from "./Reporting.vue?vue&type=template&id=036841fb&scoped=true"
import script from "./Reporting.vue?vue&type=script&lang=js"
export * from "./Reporting.vue?vue&type=script&lang=js"
import style0 from "./Reporting.vue?vue&type=style&index=0&id=036841fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036841fb",
  null
  
)

/* custom blocks */
import block0 from "./Reporting.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports